import { ChatBotSettingsFormValues } from "../types";
import { resolveChatBotSettings } from "./resolveChatBotSettings";

export const transformChatBotSettingsToFormValues = (
  settingsObject: Record<string, unknown>
): ChatBotSettingsFormValues => {
  const resolvedSettings = resolveChatBotSettings(settingsObject);

  return {
    chatName: resolvedSettings.chatName,
    agentName: resolvedSettings.agentName,
    welcomeMessage: resolvedSettings.welcomeMessage,
    senderMessageBackgroundColor: resolvedSettings.senderMessageBackgroundColor,
    theme: resolvedSettings.theme,
    buttonColor: resolvedSettings.buttonColor,
    alignment: resolvedSettings.alignment,
    bottomSpacing: resolvedSettings.bottomSpacing,
    sideSpacing: resolvedSettings.sideSpacing,
    chatImage: resolvedSettings.chatImageUrl,
    agentImage: resolvedSettings.agentImage,
    buttonIcon: resolvedSettings.buttonIcon,
    ctas: Array.from({ length: 2 }, (_, index) => ({
      id: `cta-${index + 1}`,
      value: resolvedSettings.ctas[index] ?? "",
    })),
    suggestions: Array.from({ length: 6 }, (_, index) => ({
      id: `suggestion-${index + 1}`,
      value: resolvedSettings.suggestions[index] ?? "",
    })),
    ctaVisual: resolvedSettings.ctaVisual
      ? resolvedSettings.ctaVisual.id.startsWith("default")
        ? resolvedSettings.ctaVisual.id
        : resolvedSettings.ctaVisual.url
      : null,
  };
};
